import React from 'react'
import { pdf } from '@react-pdf/renderer'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import ServiceOrderPDF from '_views/service-order/service-order-pdf'

export async function generateServiceOrderPdf({
  activeBudget,
  serviceOrder,
  formattedAddress,
  agencyLogo,
  systemParameters,
  serviceOrderId,
  selectedOptions,
  timelineEvents = {},
  notesComments = [],
}) {
  const activeBudgetJs = activeBudget?.toJS ? activeBudget.toJS() : activeBudget
  let latestBudget = activeBudgetJs
  const budgetList = serviceOrder?.budget?.toJS ? serviceOrder.budget.toJS() : serviceOrder?.budget
  if (Array.isArray(budgetList) && budgetList.length) {
    const [latestFromList] = budgetList.slice().sort((a, b) => {
      const aDate = a?.createdAt ? new Date(a.createdAt).getTime() : 0
      const bDate = b?.createdAt ? new Date(b.createdAt).getTime() : 0
      if (bDate !== aDate) return bDate - aDate
      const aId = a?.id || 0
      const bId = b?.id || 0
      return bId - aId
    })
    latestBudget = latestFromList
  }

  const pdfDocument = (
    <ServiceOrderPDF
      budget={latestBudget || { budgetItems: [], totalPrice: 0 }}
      property={formattedAddress}
      serviceOrder={serviceOrder}
      agencyLogo={agencyLogo}
      dateBudget={new Date().toISOString()}
      installments={[]}
      showReferaValue={false}
      agency={null}
      systemParameters={systemParameters}
      selectedOptions={selectedOptions}
      timelineEvents={timelineEvents}
      notesComments={notesComments}
    />
  )

  const blob = await pdf(pdfDocument).toBlob()

  const zip = new JSZip()
  zip.file(`Relatorio_Chamado_${serviceOrderId}.pdf`, blob)
  try {
    // Só adiciona nota fiscal se attachmentsFinished estiver selecionado
    if (selectedOptions?.attachmentsFinished) {
      const attachments = serviceOrder?.attachments?.toJS
        ? serviceOrder.attachments.toJS()
        : serviceOrder?.attachments || []

      const invoices = Array.isArray(attachments)
        ? attachments.filter(att => {
            const fileType = att?.fileType || att?.get?.('fileType')
            return fileType === 'invoice'
          })
        : []

      if (invoices.length) {
        const sorted = invoices.slice().sort((a, b) => {
          const aDate = a?.createdAt || a?.get?.('createdAt')
          const bDate = b?.createdAt || b?.get?.('createdAt')
          const aTs = aDate ? new Date(aDate).getTime() : 0
          const bTs = bDate ? new Date(bDate).getTime() : 0
          if (bTs !== aTs) return bTs - aTs
          const aId = a?.id || a?.get?.('id') || 0
          const bId = b?.id || b?.get?.('id') || 0
          return bId - aId
        })

        const latestInvoice = sorted[0]
        const invoiceUrl = latestInvoice?.file || latestInvoice?.get?.('file')

        if (invoiceUrl && typeof invoiceUrl === 'string') {
          const resp = await fetch(invoiceUrl)
          if (resp.ok) {
            const ct = resp.headers.get('content-type') || ''
            let ext = 'pdf'
            if (ct.includes('xml')) ext = 'xml'
            else if (ct.includes('text')) ext = 'txt'
            const invoiceBlob = await resp.blob()
            zip.file(
              `Execucao_do_Servico/Nota_Fiscal_Finalizacao_${serviceOrderId}.${ext}`,
              invoiceBlob
            )
          }
        }
      }
    }
  } catch (e) {
    // silently ignore invoice download errors to not block main zip
  }

  const zipBlob = await zip.generateAsync({ type: 'blob' })
  saveAs(zipBlob, `Relatorio_Chamado_${serviceOrderId}.zip`)
}
